import React from "react"
import ForHealthCoachHeaderSection from "./shared/forHealthCoachHeaderSection/ForHealthCoachHeaderSection"
import ForHealthCoachFeatures from "./shared/forHealthCoachFeatures/ForHealthCoachFeatures"
import ForHealthCoachTraining from "./shared/forHealthCoachTraining/ForHealthCoachTraining"
import ForHealthCoachHelpSection from "./shared/forHealthCoachHelpSection/ForHealthCoachHelpSection"
import ForHealthCoachPrices from "./shared/forHealthCoachPrices/ForHealthCoachPrices"
import ForHealthCoachKeyFeatures from "./shared/forHealthCoachKeyFeatures/ForHealthCoachKeyFeatures"

const ForHealthCoach = ({
  toggleActiveIncomeProgram,
  activeIncomeProgram,
  toggleActiveOrganizedProgram,
  beOrganizedProgram,
  toggleActiveOnlineConsultationProgram,
  onlineConsultationProgram,
  healthCoachHeaderImage,
  healthCoachProgramImages,
  healthCoachHelpImages,
  images,
  handleChangeEmail,
  handleSubmit,
  email,
  path,
  errors,
  loading,
  locale,
}) => {
  return (
    <div className="for-health-coach-wrapper">
      <ForHealthCoachHeaderSection
        locale={locale}
        path={path}
        loading={loading}
        handleChangeEmail={handleChangeEmail}
        handleSubmit={handleSubmit}
        email={email}
        errors={errors}
        healthCoachHeaderImage={healthCoachHeaderImage}
      />
      <ForHealthCoachFeatures locale={locale} />
      <ForHealthCoachTraining
        locale={locale}
        healthCoachProgramImages={healthCoachProgramImages}
        onlineConsultationProgram={onlineConsultationProgram}
        toggleActiveOnlineConsultationProgram={
          toggleActiveOnlineConsultationProgram
        }
        beOrganizedProgram={beOrganizedProgram}
        toggleActiveOrganizedProgram={toggleActiveOrganizedProgram}
        activeIncomeProgram={activeIncomeProgram}
        toggleActiveIncomeProgram={toggleActiveIncomeProgram}
      />
      <ForHealthCoachHelpSection
        locale={locale}
        healthCoachHelpImages={healthCoachHelpImages}
      />
      <ForHealthCoachPrices locale={locale} />
      <ForHealthCoachKeyFeatures images={images} locale={locale} />
    </div>
  )
}

export default ForHealthCoach
